// ==============================
// Imports
// ==============================

// Libraries
import { ReactNode } from 'react';

// Types
interface ModalType {
  children?: ReactNode;
  isOpen: boolean;
  toggle: () => void;
  width?: string;
  height?: string;
  overlayClassName?: string;
}

// ==============================
// Render
// ==============================
export default function ReuseableModal(props: ModalType) {
  return (
    <>
      {props.isOpen && (
        <div
          className={`standard-modal-overlay ${props.overlayClassName || ''}`}
        >
          <div
            className={`standard-modal-paper modal-box ${props.width} ${props.height}`}
            style={{
              scrollbarWidth: 'thin',
            }}
          >
            {props.children}
          </div>
        </div>
      )}
    </>
  );
}
